module.exports = __webpack_public_path__ + "img/about-img2.762c24fc.png";